<!-- Bottom Navigation Bar solo visible en móviles -->
<nav class="bottom-nav d-md-none">
  <a class="nav-item" routerLink="/" title="Inicio">
    <i class="fas fa-home"></i>
  </a>
  <a class="nav-item" (click)="focusSearch()" title="Buscar">
    <i class="fas fa-search"></i>
  </a>
  <a class="nav-item" routerLink="/user/dashboard/perfil" title="Carrito">
    <i class="fas fa-shopping-basket"></i>
    <span
      class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger animate__animated animate__pulse animate__infinite">
      {{ cantidad$ | async }}
    </span>
  </a>
  <a class="nav-item" (click)="openModalLogin()" title="Cuenta">
    <i class="fas fa-user-circle"></i>
  </a>
</nav>